
import {useEffect, useState} from "react";
import {findPastBookingsWithPagination} from "../api/apiClient";

export const usePastBookings = (page, reloadTrigger) => {
    const [pastBookings, setPastBookings] = useState([]);
    const [pastBookingsPagination, setPastBookingsPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const pastBookingsWithPagination = findPastBookingsWithPagination(page, abortController.signal);

        pastBookingsWithPagination
            .then(
                (data) => {
                    const bookings = data.bookings;
                    const pagination = data.pagination;

                    setPastBookings(bookings)
                    setPastBookingsPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, reloadTrigger]);

    return {pastBookings : pastBookings, pastBookingsPagination : pastBookingsPagination};
};